import { getPricingOfAccountWhatsapp2Campaign } from "../types/account_campaign_pricing_whatsapp_types";


const initState = {
  data: [],
  loading: false,
  error: null,
  cellLoading: null,
};

export default function accountCampaignPricingWhatsapp2Reducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountWhatsapp2Campaign.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountWhatsapp2Campaign.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountWhatsapp2Campaign.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
